import { PropTypes } from 'prop-types'
import { Translate } from 'react-redux-i18n'
import { CoachMark } from '../../../coachMark'
import { coachMarkRoutes } from '../../../coachMark/constants'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { BuyButton } from './BuyButton'
import { AddInfo } from './addInfo'
import { Header } from './header'
import classes from './index.module.scss'
import { SelectedCriteria } from './selectedCriteria'
import { TotalInfo } from './totalInfo'

export const ExportFileSetting = ({ navigateToSelectScreen }) => {
  return (
    <CoachMark id={coachMarkRoutes['/screening/exportFileSettings']}>
      <Element className={classes.exportFileSetting}>
        <Element
          elementName="button"
          className={classes.backBtn}
          style={{ color: '#3A414B', borderColor: '#D5D5D5' }}
        >
          <Element className="dFlex alignItemsCenter" style={{ gap: 4 }}>
            <Icon className="icon-arrow-left" style={{ fontSize: 8 }} />
            <Element elementName="span" onClick={navigateToSelectScreen}>
              <Translate value="screening.BACK_TO_SCREENING" />
            </Element>
          </Element>
        </Element>

        <Element
          className={classes.screenName}
          style={{ fontSize: 20, color: '#191D25' }}
        >
          <Translate value="screening.EXPORT_FILE_SETTING" />
        </Element>

        <Element
          className={classes.mainContent}
          style={{ borderColor: '#D5D5D5' }}
        >
          <Header />
          <Element className={classes.content}>
            <Element style={{ borderColor: '#D5D5D5' }}>
              <SelectedCriteria />
            </Element>
            <Element style={{ borderColor: '#D5D5D5' }}>
              <AddInfo />
            </Element>
            <Element>
              <TotalInfo />
            </Element>
          </Element>
        </Element>

        <Element className="dFlex justifyContentEnd">
          <BuyButton />
        </Element>
      </Element>
    </CoachMark>
  )
}

ExportFileSetting.propTypes = {
  navigateToSelectScreen: PropTypes.func.isRequired,
}
